import { useEffect, useState } from "react";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { getLocalStorage } from "../utils/localStorage";
import { useDispatch, useSelector } from "react-redux";
import { refreshToken } from "../store/user";

/**
 * @param {{
    method: String
    path: String
    initialState: Any
    data: Function
  }}
*/
export default function useSignalR({
  param = "",
  path = "",
  initialState = "",
  data = () => null,
}) {
  const { data: auth } = useSelector((state) => state.auth);
  const [state, setState] = useState(initialState);
  const dispatch = useDispatch();

  const handleError = (err) => {
    if (
      (err?.status === 401 && !err?.config.url.includes("refresh-login")) ||
      err?.statusCode === 401
    ) {
      dispatch(refreshToken());
    }
  };

  useEffect(() => {
    const _tokens = getLocalStorage("_tokens", null, true);
    if (!!_tokens) {
      const connection = new HubConnectionBuilder()
        .withAutomaticReconnect()
        .withUrl(process.env.REACT_APP_BACKEND_SIGNALR_URL + "/updateHub", {
          accessTokenFactory: () => _tokens.token,
        })
        .build();

      if (connection) {
        connection
          .start()
          .then(() => {
            connection.on(path, data);
            if (!!param)
              return connection
                .invoke("SendLastPositionOrderToCaller", param)
                .catch(({ response: err }) => handleError(err));
            return connection
              .invoke("SendLastPositionToCaller")
              .catch(({ response: err }) => handleError(err));
          })
          .catch((err) => {
            handleError(err);
          });
      }
      return () => {
        connection && connection.stop();
      };
    }
    // eslint-disable-next-line
  }, [auth?.token]);

  return [state, setState];
}
